<template>
	<section class="intro-filtered" data-url="">
		<div class="filter-logo logo-moma" v-if="feed === 'moma'">
			<svg
				version="1.1"
				id="Layer_1"
				xmlns="http://www.w3.org/2000/svg"
				xmlns:xlink="http://www.w3.org/1999/xlink"
				x="0px"
				y="0px"
				viewBox="0 0 486.7 121.5"
				style="enable-background:new 0 0 486.7 121.5;"
				xml:space="preserve"
			>
				<g>
					<path
						d="M319.2,0h43.9v121.5h-28.8V31.1l-22.5,90.4h-26.1l-22.2-90.7v90.7h-27.2V0h45.7l18.5,76.8L319.2,0z M82.8,0h44.1v121.5h-29
					V31.1l-22.4,90.4H49.4L27.2,30.8v90.7H0V0h45.7l18.5,76.8L82.8,0z M449.4,0h-37.9l-39.4,121.5h28.7l7-22.5h42l6.8,22.5h30.1
					L449.4,0z M415.4,76.1l14.3-46.8l13.4,46.8H415.4z M181.5,36.3c-22.5,0-43.7,14.9-43.7,42.4v1.8c0,27.9,21.2,42.6,43.7,42.6
					c22.7,0,43.9-14.7,43.9-42.6v-1.8C225.4,51.2,204.1,36.3,181.5,36.3z M196.2,81.7c0,15.4-6.2,21.7-14.7,21.7
					c-8.4,0-14.6-6.3-14.6-21.7v-4.1c0-15.7,6.2-21.7,14.6-21.7c8.6,0,14.7,6,14.7,21.7V81.7z"
					/>
				</g>
			</svg>
		</div>
		<div class="filter-logo logo-momaps1" v-if="feed === 'ps1'">
			<svg
				version="1.1"
				xmlns="http://www.w3.org/2000/svg"
				xmlns:xlink="http://www.w3.org/1999/xlink"
				xmlns:a="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/"
				x="0px"
				y="0px"
				width="486.7px"
				height="271.7px"
				viewBox="0 0 486.7 271.7"
				style="enable-background:new 0 0 486.7 271.7;"
				xml:space="preserve"
			>
				<defs></defs>
				<g>
					<path
						d="M319.2,0h43.9v121.5h-28.8V31.1l-22.5,90.4h-26.1l-22.2-90.7v90.7h-27.2V0h45.7l18.5,76.8L319.2,0z M82.8,0h44.1v121.5h-29
					V31.1l-22.4,90.4H49.4L27.2,30.8v90.7H0V0h45.7l18.5,76.8L82.8,0z M449.4,0h-37.9l-39.4,121.5h28.7l7-22.5h42l6.8,22.5h30.1
					L449.4,0z M415.4,76.1l14.3-46.8l13.4,46.8H415.4z M181.5,36.3c-22.5,0-43.7,14.9-43.7,42.4v1.8c0,27.9,21.2,42.6,43.7,42.6
					c22.7,0,43.9-14.7,43.9-42.6v-1.8C225.4,51.2,204.1,36.3,181.5,36.3z M196.2,81.7c0,15.4-6.2,21.7-14.7,21.7
					c-8.4,0-14.6-6.3-14.6-21.7v-4.1c0-15.7,6.2-21.7,14.6-21.7c8.6,0,14.7,6,14.7,21.7V81.7z"
					/>
					<g>
						<path
							d="M0,148.7h45.8c32.2,0,48.4,15.9,48.4,39v1.5c0,23.5-16.2,39-48.4,39H31.6v42H0V148.7z M31.6,171.1v36.3h13.1
						c12.8,0,18.3-7.1,18.3-17.8v-1.9c0-10.9-5.5-16.5-18.3-16.5H31.6z"
						/>
						<path
							d="M195.8,233.6c0,21.5-15.7,38.1-46.2,38.1c-29.6,0-48.9-14.6-51.8-37.1l30-2.6c2.3,11.8,9.4,18,22.7,18
						c9.6,0,16.4-4.4,16.4-11.7c0-8.3-7.3-11.8-25.4-17c-26.6-7.3-39-16.4-39-38.1c0-23.7,20.1-36.1,42.9-36.1c22.5,0,42,7.6,47,32.9
						l-28.5,2.9c-3.1-11.5-11.3-14.6-18.8-14.6c-8.6,0-14.1,4.5-14.1,11.2c0,6.6,6.8,10.9,22.8,14.9C180.6,201.4,195.8,210,195.8,233.6
						z"
						/>
						<path
							d="M287.2,270.2h-81.2v-19.3h26.7v-67.6c-7.1,5-18.8,8.6-29.2,9.4v-20.4c13.8-2.8,27.1-12.8,33-23.7h26.7v102.2h23.8V270.2z"
						/>
					</g>
				</g>
			</svg>
		</div>
	</section>
</template>

<script>
export default {
	name: "IntroFiltered",
	data() {
		return {};
	},
	created() {},
	mounted() {},
	props: ["rootPath", "apiPath", "feed"],
	methods: {}
};
</script>

<style lang="scss" scoped>
@import "../sass/_mq.scss";
.intro-filtered {
	position: relative;
	margin-bottom: 0;
	padding: 0;
	animation: fadein 1s forwards;
}
.filter-logo {
	padding: 24px $padIn 20px;
	border-bottom: solid 1px;
	svg {
		width: 130px;
		height: auto;
	}
}
</style>
